import * as React from "react";
import { Dropdown, OverlayTrigger, Tooltip, Form } from "react-bootstrap";
import { ModuleReports } from "../../Common/Services/ModuleReports";
import OutsideClickHandler from "react-outside-click-handler";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";


export class FacilitiesAssetTypeFilter extends React.Component<any, any> {
  private inputElement: any;
  constructor(props: any) {
    super(props);
    this.inputElement = React.createRef();
    this.state = {
      placeHolder: "All",
      filterData: [],
      Employees: [],
      inputValue: "",
    };
  }
  GetFacilityReportDropdownDetails = async (hotelIds: string) => {

    try {
      const result: any[] = await ModuleReports.GetFacilityReportDropdownDetails(hotelIds.toString(),"FCAssetTypeFilterdll");
      if (result?.length > 0) {
      debugger;

        let userList: any[] = [];

       
        this.setState({ Employees: result, filterData: result },()=>{
          if(this.props?.FcAssetTypeDetails==="" || this.props?.FcAssetTypeDetails===undefined) 
          {        
          this.props?.handelResponseStatus(result[0].value);
          }else{            
            const rowIndex = this.state.filterData.findIndex(
              (obj) =>
                obj?.value?.toLowerCase().trim() ===
                this.props?.FcAssetTypeDetails.toLowerCase().trim()
            );
             this.setState({ placeHolder: result[rowIndex]?.lable });
           
            if(rowIndex!==-1){
              this.handleDropdownChange(result[rowIndex].value)
            }
           
          }
    
        });


      }
    } catch (error) {
      // Need to handle this
      console.log(error);
    }
  };

  componentDidMount = () => {
  
    if (this.props?.hotelIds) {
      this.updateEmployeeDDL(this.props?.hotelIds);
    }
  
  };

   componentDidUpdate = (prevProps:any) => {
  
    if (prevProps?.hotelIds!=this.props?.hotelIds) {
      this.updateEmployeeDDL(this.props?.hotelIds);
    }
  
  };
  updateEmployeeDDL(hotelIds: string) {
  
    if (!hotelIds) {
      this.setState({ Employees: [], filterData: [], placeHolder: "All" });

    }
    else {
      this.GetFacilityReportDropdownDetails(hotelIds);

    }
  }



  handleLaborEmployeeSearch = (e: { target: { value: string } }) => {
  
    const updatedList = this.state.Employees.filter((item) => {
      return (
        item.lable?.toString().toLowerCase().indexOf(e.target.value.toLowerCase()) >
        -1
      );
    });
   
    this.setState({ filterData: updatedList, inputValue: e.target.value });
  }

  handleDropdownChange = (value: any) => {
    //this.props.onLaborEmployeeChange(e);
    this.props?.handelResponseStatus(value);
    this.resetSerchBox();
  }

  resetSerchBox = () => {
    this.setState({ inputValue: "" });
    this.setState({ filterData: this.state.Employees });
  };
  employeeSelectModal = (eventKey: any) => {
    this.setState({ inputValue: "" });
    this.setState({ placeHolder: eventKey });
  };
  render() {


    const onFocusInput = (eventKey: any) => {
      setTimeout(() => {
        this.inputElement.current.focus();
      }, 100);
    };

    return (
      <Dropdown
        className="single-select"
        onSelect={this.employeeSelectModal}
        onClick={onFocusInput}
      >
        <Dropdown.Toggle id="Modal-LaborEmployees">
          {this.state.placeHolder === "Select Employees" && (
            <span className="placeholder">{this.state.placeHolder}</span>
          )}
          {this.state.placeHolder !== "Select Employees" && (
            // <OverlayTrigger
            //   placement="bottom-start"
            //   delay={{ show: 250, hide: 400 }}
            //   overlay={
            //     <Tooltip id={"Employee" + this.state.placeHolder}>
            //       {this.state.placeHolder}
            //     </Tooltip>
            //   }
            // >
            //   <span
            //     style={{
            //       width: " 95%",
            //       overflow: "hidden",
            //       textOverflow: "ellipsis",
            //       display: "inline-block",
            //     }}
            //   >
            //     {this.state.placeHolder}
            //   </span>
            // </OverlayTrigger>
            <EllipsisWithTooltip placement="bottom">{this.state.placeHolder}</EllipsisWithTooltip>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <div className="search-sec">
            <input
              type="text"
              className="form-control"
              onChange={this.handleLaborEmployeeSearch}
              placeholder="Filter Asset Type"
              value={this.state.inputValue}
              ref={this.inputElement}
            />
          </div>
          <div className="list-area">
            {this.state.filterData.map((item: any, idx: any) => (
              // <OverlayTrigger
              //   placement="bottom-start"
              //   delay={{ show: 250, hide: 400 }}
              //   overlay={
              //     <Tooltip id={"Employeedata" + idx}>{item.lable}</Tooltip>
              //   }
              //   key={idx}
              // >
              //   <Dropdown.Item
              //     eventKey={item.lable}
              //     onClick={() => this.handleDropdownChange(item.value)}
              //   >
              //     {item.lable}
              //   </Dropdown.Item>
              // </OverlayTrigger>
              <Dropdown.Item
                eventKey={item.lable}
                onClick={() => this.handleDropdownChange(item.value)}
              >
                <EllipsisWithTooltip placement="bottom">{item.lable}</EllipsisWithTooltip>
              </Dropdown.Item>
            ))}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}